<template>
     <div>
      <h1>{{ $t('help.ISAStatcallsUnansweredCount_title') }}</h1>
      <p class="text-justify">
          {{ $t('Total unanswered calls is the total of calls when a phone was ringing and it was not taken.') }}
      </p>
      
    </div>
</template>

<script>

export default  {
  components: {    
  },  
  data() {
    return {      
    }
  },
  watch : {    
  },    
  methods: {        
    },
  mounted() {            
  },
  name: "ISAHelpModalContent"
}
</script>

<style lang="scss" scoped>
h1 {
  font-weight: 700;
}

.modal-title {
  font-weight: 700;
}

</style>
